import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useGa from 'Client/hooks/useGa';

const useAppTracking = () => {
    const gaTracking = useGa();
    const { p100HotjarTracker } = useFeatureToggle();

    const trackAppWideVariations = () => {
        gaTracking.trackVariation('p100HotjarTracker', p100HotjarTracker);
    };

    return {
        trackAppWideVariations,
    };
};

export default useAppTracking;
